import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {BaseView} from '../../view/base.view';
import {AbstractDownloadActionService} from '../../service/v2/service/download/abstractDownloadAction.service';
import {PdfPreviewModalComponent, PdfPreviewModalInput} from '../pdf-preview-modal/pdf-preview-modal.component';
import {DialogController} from '../../../common/dialog/dialogController';
import {IDownloadActionService} from '../../service/v2/service/download/iDownloadAction.service';

@Component({
    selector: 'app-download-button',
    templateUrl: './download-button.component.html',
})
export class DownloadButtonComponent<Payload> extends BaseView implements OnInit, OnChanges, AfterViewInit, OnDestroy {

    loading = false;

    @Input() pdfPreviewMode = false;
    @Input() imagePreviewMode = false;
    @Input() entity: any;
    @Input() permission: string;
    @Input() filename: string;
    @Input() label: string;
    @Input() size: string;
    @Input() iconName = 'download';
    @Input() fill = 'clear';
    @Input() disabled = false;
    @Input() withPadding = true;
    @Input() withMargin = true;
    @Input() color = 'accent';
    @Input() actionSuccessMessage: string;
    @Input() service: IDownloadActionService<Payload>;
    @Input() downloadOnRefresh = false;
    @Input() downloadOnInit = false;
    @Input() buildPayload: () => Payload;
    @Input() payload: Payload;
    @Input() tooltip = 'Télécharger';

    @Output() actionErrorEvent: EventEmitter<any> = new EventEmitter();
    @Output() actionSuccessEvent: EventEmitter<void> = new EventEmitter();
    @Output() downloadStartedEvent: EventEmitter<Blob> = new EventEmitter();

    objectUrl: string;

    constructor(private dialogController: DialogController) {
        super();
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.objectUrl) {
            window.URL.revokeObjectURL(this.objectUrl);
        }
    }

    ngAfterViewInit() {
        if (this.downloadOnInit) {
            this.executeDownload();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        const entityChange = changes['entity'];
        if (entityChange && !entityChange.isFirstChange() && this.downloadOnRefresh === true) {
            this.executeDownload();
        }
    }



    executeDownload() {
        this.executeDownloadWithPayload(this.payload ? this.payload : this.buildPayload());
    }

    executeDownloadWithPayload(payload: Payload) {
        if (this.objectUrl) {
            window.URL.revokeObjectURL(this.objectUrl);
        }
        this.loading = true;
        this.service.executeAction(payload)
            .then((blob) => {
                // console.logByType['download result', blob]);
                if (this.pdfPreviewMode) {
                    this.showAddPreviewDialog(blob, true);
                } else if (this.imagePreviewMode) {
                    this.showAddPreviewDialog(blob, false);
                } else {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.filename?.replace(/"/g, '');
                    link.click();
                    this.downloadStartedEvent.emit(blob);
                }
                if (this.actionSuccessMessage) {
                    this.toastControl.presentConfirmation(this.actionSuccessMessage);
                }
                this.actionSuccessEvent?.emit();
            })
            .catch((e) => {
                this.toastControl.presentError(e);
                this.actionErrorEvent.emit(e);
            })
            .finally(() => this.loading = false);
    }

    showAddPreviewDialog(blob, pdf: boolean) {
        const input: PdfPreviewModalInput = {
            pdfBlob: pdf ? blob : undefined,
            imageBlob: !pdf ? blob : undefined,
            fileName: this.filename
        };
        this.dialogController.open(PdfPreviewModalComponent, input, {
            title: 'Prévisualisation'
        });
    }

}
